<template>
  <div class="home-page">
    <div class="banner">
      <img :src="HomeBanner" />
    </div>
    <!-- 用户信息 -->
    <UserInfo :info="userInfo" />
    <!-- 提示绑定 -->
    <div class="tips-bind" v-if="userInfo.yellow_text">{{userInfo.yellow_text}}</div>
    <!-- 未购买 -->
    <div class="tips-bind erro" v-if="userInfo.red_text">{{userInfo.red_text}}</div>
    <div class="open flex-bc">
      取水通知
      <van-switch :value="open" @input="onInput" size="20" active-color="#07c160" />
    </div>
    <!-- 孩子列表 -->
    <!-- <ChildItem :sex="1" @openChiceClass="class_show = true" /> -->
    <ChildItem
      v-for="(item, index) in cupList"
      :key="index"
      :sex="item.student_gender * 1"
      :loss_status="item.status * 1 === 2"
      :item="item"
      :buyUrl="userInfo.buy_cup_url"
      @openChiceClass="ChiceClass"
      @openChoiceModel="Addchoice"
      @openEditName="EditName(item)"
    />
    <!-- 添加水杯编号 -->
    <div class="add-btn">
      <Btn title="添加水杯编号" @click="Addchoice" />
    </div>
    <!-- 客服 -->
    <div class="service-btn">
      <a class="phone" :href="'tel:' + kefu">
        <img :src="IconService" />
        <div class="title">客服</div>
      </a>
    </div>
    <!-- 添加类型选择 -->
    <van-popup v-model="choice_open" position="bottom" :style="{ borderRadius: '.16rem .16rem 0 0' }">
      <ModelChoice :edit="edit" />
    </van-popup>
    <!-- 班级 -->
    <van-popup v-model="class_show" position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        @confirm="editConfirm"
        @cancel="class_show = false"
        :columns="classList"
      />
    </van-popup>
    <!-- 编辑学生名称 -->
    <van-popup v-model="edit_show" :style="{ borderRadius: '.1rem' }">
      <EditPopup @refresh="GetIndex" @close="edit_show = false" :info="studentInfo" ref="editpopup" />
    </van-popup>
  </div>
</template>

<script>
  import UserInfo from './components/UserInfo'
  import EditPopup from './components/EditPopup'
  import { SetImage } from '@/utils/Image'
  export default {
    data () {
      return {
        class_show: false,
        choice_open: false,
        userInfo: {},
        kefu: '',
        cupList: [],
        edit: 0,
        classList: [],
        class_item: {},
        edit_show: false,
        studentInfo: {},
        editpopup: null,
        open: false
      }
    },
    methods: {
      GetIndex () {
        this.edit_show = false
        this.$Get('Common.index').then(res => {
          this.userInfo = res.data
          this.kefu = res.data.kefu
          this.cupList = res.data.cupList
        })
        this.getTemplate()
      },
      Addchoice (edit = 0) {
        console.log(edit)
        this.edit = edit
        this.choice_open = true
      },
      ChiceClass (item) {
        console.log(item)
        this.class_item = item
        this.classList = item.classList
        this.class_show = true
      },
      EditName (item) {
        this.editpopup = this.$refs['editpopup']
        this.studentInfo = item
        if (this.editpopup) {
          this.editpopup.name = item.student_name
        }
        this.edit_show = true
      },
      editConfirm (e) {
        this.class_show = false
        this.$Post('Common.editClass', {
          cup_id: this.class_item.id,
          class_id: e.id
        }).then(res => {
          this.GetIndex()
        })
      },
      getTemplate () {
        this.$Get('Common.getTemplate').then((res) => {
          this.open = !(res.data.is_stop * 1)
        })
      },
      onInput () {
        if (this.open) {
          this.stopTemplate()
        } else {
          this.startTemplate()
        }
      },
      stopTemplate () {
        this.$Post('Common.stopTemplate').then((res) => {
          this.open = false
        })
      },
      startTemplate () {
        this.$Post('Common.startTemplate').then((res) => {
          this.open = true
        })
      }
    },
    created () {
      this.GetIndex()
    },
    mounted () {
      this.editpopup = this.$refs['editpopup']
    },
    computed: {
      ...SetImage(['HomeBanner', 'IconService'])
    },
    components: {
      UserInfo,
      EditPopup
    }
  }
</script>

<style lang="less" scoped>
  .home-page {
    .p(1.04rem .24rem .5rem);
    position: relative;
    .banner {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      img {
        .w();
      }
    }
    .tips-bind {
      .fz(.26rem);
      .c(#fd9e0c);
      .p(.24rem .3rem);
      .br(.1rem);
      .bg(#fffbee);
      .mb(.3rem);
      .lh(1.5);
      &.erro {
        .bg(#fff7f8);
        .c(#ff2c4c);
      }
    }
    .open {
      font-size: .28rem;
      margin-bottom: .2rem;
    }
    .add-btn {
      .mt(.7rem);
      // position: fixed;
      // bottom: 1.55rem;
      // left: .3rem;
      // right: .3rem;
    }
    .service-btn {
      .w(.9rem);
      .h(.9rem);
      .bg(#fff);
      z-index: 11;
      box-shadow: 0rem 0rem 0.18rem 0rem rgba(0, 176, 244, 0.1);
      .br(.45rem);
      .flex-ccc();
      position: fixed;
      bottom: 3.18rem;
      right: .24rem;
      img {
        .w(.4rem);
        .h(.44rem);
        .mb(.05rem);
      }
      .title {
        .fz(.2rem);
        .c(#00b0f4);
        a {
          .c(#00b0f4);
        }
      }
    }
  }
</style>
